/* bakerly PDP sticky cart */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.formPassed = false;
      this.footerVisible = false;
    }

    connectedCallback() {
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.footer = document.getElementById("footer");
      this.stickyButton = this.querySelector("#AddToCartSticky");

      if (!this.form || !this.stickyButton) {
        return;
      }

      this.setupObservers();
      this.setupButtonSync();
      // Click handling is kept on the markup so it remains independent of legacy product.js errors.
    }

    setupAddToCart() {
      this.stickyButton.addEventListener("click", (event) => {
        event.preventDefault();

        const mainButton = this.form.querySelector(
          ".single-add-to-cart-button:not(#AddToCartSticky)"
        );

        if (
          !mainButton ||
          mainButton.disabled ||
          mainButton.getAttribute("aria-disabled") === "true" ||
          mainButton.classList.contains("loading")
        ) {
          return;
        }

        this.form.requestSubmit(mainButton);
      });
    }

    setupButtonSync() {
      this.pricingData = this.querySelector(
        `#sticky-pricing-data-${this.dataset.section}--sticky`
      );

      const sync = () => {
        const mainButton = this.form.querySelector(
          ".single-add-to-cart-button:not(#AddToCartSticky)"
        );

        if (!mainButton) return;

        const mainText =
          (mainButton.getAttribute("data-content") || mainButton.textContent || "")
            .replace(/\s+/g, " ")
            .trim();
        const textParts = mainText.split(/\s+-\s+/);
        const actionText = textParts.shift() || "";
        const pricingParts = (this.pricingData?.textContent || "")
          .split("||")
          .map((value) => value.trim());
        const currentPrice = textParts.join(" - ") || pricingParts[0] || "";
        const comparePrice = pricingParts[1] || "";
        const soldOut =
          mainButton.disabled || mainButton.classList.contains("sold-out");
        const visibleText = this.stickyButton.querySelector(
          ".product-add-to-cart-sticky--button-text"
        );

        if (visibleText) {
          visibleText.textContent = "";

          const label = document.createElement("span");
          label.className = "product-add-to-cart-sticky--button-label";
          label.textContent = soldOut ? actionText : `${actionText} –`;
          visibleText.appendChild(label);

          if (!soldOut && currentPrice) {
            const current = document.createElement("span");
            current.className = "product-add-to-cart-sticky--current-price";
            current.textContent = currentPrice;
            visibleText.appendChild(current);

            if (comparePrice && comparePrice !== currentPrice) {
              const compare = document.createElement("del");
              compare.className = "product-add-to-cart-sticky--compare-price";
              compare.textContent = comparePrice;
              visibleText.appendChild(compare);
            }
          }
        }

        const accessibleText = soldOut
          ? actionText
          : [actionText, currentPrice, comparePrice ? `regular price ${comparePrice}` : ""]
              .filter(Boolean)
              .join(" - ");

        this.stickyButton.setAttribute("data-content", accessibleText);
        this.stickyButton.setAttribute("aria-label", accessibleText);
        this.stickyButton.disabled = mainButton.disabled;
        this.stickyButton.classList.toggle("sold-out", soldOut);
        this.stickyButton.classList.toggle(
          "loading",
          mainButton.classList.contains("loading")
        );

        if (mainButton.getAttribute("aria-disabled") === "true") {
          this.stickyButton.setAttribute("aria-disabled", "true");
        } else {
          this.stickyButton.removeAttribute("aria-disabled");
        }
      };

      sync();

      this.formObserver = new MutationObserver(sync);
      this.formObserver.observe(this.form, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ["data-content", "disabled", "class"],
      });

      if (this.pricingData) {
        this.pricingObserver = new MutationObserver(sync);
        this.pricingObserver.observe(this.pricingData, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    setupObservers() {
      const mainButton =
        this.form.querySelector(".single-add-to-cart-button:not(#AddToCartSticky)") ||
        this.form;

      this.triggerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== mainButton) return;

          if (entry.isIntersecting) {
            this.formPassed = false;
          } else {
            this.formPassed = entry.boundingClientRect.bottom < 0;
          }

          this.updateVisibility();
        });
      }, { threshold: [0, 1] });

      this.triggerObserver.observe(mainButton);

      if (this.footer) {
        this.footerObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        }, { threshold: 0 });

        this.footerObserver.observe(this.footer);
      }
    }

    updateVisibility() {
      const shouldShow = this.formPassed && !this.footerVisible;
      this.classList.toggle("sticky--visible", shouldShow);
      this.setAttribute("aria-hidden", shouldShow ? "false" : "true");

      if (shouldShow) {
        this.stickyButton.removeAttribute("tabindex");
      } else {
        this.stickyButton.setAttribute("tabindex", "-1");
      }
    }

    disconnectedCallback() {
      if (this.triggerObserver) this.triggerObserver.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
      if (this.formObserver) this.formObserver.disconnect();
      if (this.pricingObserver) this.pricingObserver.disconnect();
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}
